import { FormLabel } from '@/components/FormLabel'
import { useAuth } from '@/context/AuthContext'
import { useGetAvailableBusinessmen } from '@/hooks/useInsuranceParams'
import { insuranceParamsContext } from '@/layouts/Wizard'
import { Box, FormControl, HStack, Select } from '@chakra-ui/react'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

export const CreateInsuranceAsSomeoneElse = () => {

    const { insuranceParamsId } = useContext(insuranceParamsContext)
    const { data: dataBusinessmen } = useGetAvailableBusinessmen(insuranceParamsId!)
    const { user } = useAuth() ?? {}
    const { register, getValues } = useFormContext()

    return <>
        {dataBusinessmen?.data &&
            dataBusinessmen?.data.length > 0 &&
            user!.allowCreateInsuranceAsSomeoneElse && (
                <FormControl>
                    <FormLabel tooltip="Slouží pro propsání klienta a smlouvy pod jiného získatele/správce dle výběru níže. V případě, že chcete doplnit další osobu obraťte se s žádostí na carkulka@okholding.cz">
                        Sjednání za jiného uživatele
                    </FormLabel>

                    <Box sx={{ display: 'grid', gap: 4 }}>
                        <HStack>
                            <FormLabel tooltip="Klient bude zapsán pod vybraným získatelem. V případě, že tyto hodnoty měnit nechcete, ponechejte pole prázdné.">
                                Ziskatel
                            </FormLabel>
                            <Select
                                id="businessmanId"
                                {...register('businessmanId')}
                                defaultValue={getValues('businessmanId') ?? ''}
                            >
                                <option value="">Vyberte ziskatele</option>

                                {dataBusinessmen?.data.map((x) => (
                                    <option value={x.id} key={x.id}>
                                        {x.fullname}
                                    </option>
                                ))}
                            </Select>
                        </HStack>

                        <HStack>
                            <FormLabel tooltip="Smlouva bude zapsaná pod vybraného správce. V případě, že tyto hodnoty měnit nechcete, ponechejte pole prázdné.">
                                Správce
                            </FormLabel>
                            <Select
                                id="businessmanId"
                                {...register('managerId')}
                                defaultValue={getValues('managerId') ?? ''}
                            >
                                <option value="">Vyberte správce</option>

                                {dataBusinessmen?.data.map((x) => (
                                    <option value={x.id} key={x.id}>
                                        {x.fullname}
                                    </option>
                                ))}
                            </Select>
                        </HStack>
                    </Box>
                </FormControl>
            )}
            </>
}